export class ShowLastRecordValveUseCase {
  constructor(logValveRepository) {
    this.logValveRepository=logValveRepository
  }
  async execute(TABLE) {
    // TABLE -> Nome da válvula e também nome da tabela no banco
    const logs=await this.logValveRepository.showFirstRecordByTable(TABLE)
    // Caso tenha então irá apagar eles do banco
    if(!logs){
      return []
    }
    return logs[0]
  }
}
